export const SKIP_RECAPTCHA_INTERCEPTOR = 'skip-recaptcha-interceptor' as const;
export const X_CAPTCHA_TOKEN = 'x-captcha-token' as const;
